import React from "react";
import { connect } from "react-redux";
import { Form, Formik } from "formik";
import { Button, Col, Container, Row } from "react-bootstrap";
import { traerPalabrasTabla, utilActions} from "../../_actions";
import { ventasService } from "../../_services";
import { buscadorConstants } from "../../_constants";
import Moment from "react-moment";
import { busquedaActions } from "../../_actions/busqueda.actions";
import MiTabla from "../../_helpers/MiTabla";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumericFormat as NumberFormat } from "react-number-format";
import { Link } from "react-router-dom";
import authService from "../../_services/cart/authService";
import { alertConfirm, UsuarioDP } from "./utils/adminUtils";
import { history, prepareDataSearch, TIPO_EXPORT } from "../../_helpers";
import http from '../../_services/cart/http.service';
import alertService from "../../_services/cart/alert.service";
import { NavBarLateral } from "../includes";

import SweetAlert from 'react-bootstrap-sweetalert';

const tableRefUsers = React.createRef();
const bagRef = React.createRef();
const _ = require("lodash");

class ConsultasAdminList extends React.Component {
  constructor(props) {
    super(props);
    this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
  }

  state = {
    alert:undefined,
    loading: false,
    conversacion: undefined,
    nuevaBusqueda: false,
    show: false
  };

  componentDidMount() {

  }

  actualizar = () => {
    if (tableRefUsers.current) {
      tableRefUsers.current.onQueryChange();
    }
  };

  marcarCompletada = (data) => {
    const getAlert = alertConfirm('Confirmar',
        `¿Está seguro que desea marcar como completada?`,
        'Sí',
        'No',
        this.cerrarAlert,
        this.enviarCompletada,
        null,
        true
    )
    this.setState({conversacion:data, alert: getAlert});
  }

  cerrarAlert = () => {
    this.setState({conversacion:undefined, alert: undefined});
  }

  enviarCompletada = () => {
      http.post('/api/admin/consultas/completar', {id: this.state.conversacion.id}).then(
        data => {
            alertService.msg('Completada exitosamente!');
            this.setState({grabando: false});
            this.handleClose();
            this.actualizar();
        },
        error => {
            alertService.error(error)
            this.setState({grabando: false});
        }
      );
  };

  handleClose = () => {
    this.setState({
      alert: undefined,
      conversacion: undefined
    });
  };

  buscarData = (query) => {
    return new Promise((resolve, reject) => {
      if (this.state.nuevaBusqueda) query.page = 0;

      http.post('/api/admin/consultas/buscar',
        prepareDataSearch(query, "createdDate", "DESC", this.state.values))
        .then(
          (data) => {
            this.setState({ nuevaBusqueda: false });
            resolve({
              data: data.content ? data.content : [],
              page: query.page,
              totalCount: data ? data.totalElements : 0,
            });
          },
          (error) => {
            alertService.error(error);
          }
        );
    });
  };

  render() {
    if(!authService.hasAuthority("ADMIN")){
      history.push('/');
    }

    const { loading } = this.state;

    const header = [
      { title: "ID", field: "id" },
      { title: "Estado", field: "estado" },
      { title: "Tipo", field: "type" },
      {
        title: "De",
        field: "userFrom",
        render: (row) => row.contacto?? row.userFrom.username,
      },
      {
        title: "Mensaje",
        field: "mensaje",
        // Texto largo: en la card ocupa el ancho completo en vez de ir a la derecha.
        mobileBloque: true,
        render: (row) => row.mensajes[0].body,
      },
      {
        title: "Fecha",
        field: "createdDate",
        render: (row) => <Moment date={row.createdDate} format="DD/MM/YYYY HH:mm" />,
      },
      {
        title: "",
        cellStyle: { textAlign: "center" },
        render: (row) => (
          <div className="table-button">
            <Link to={"/admin/consultaDetail?id=" + row.id}>
              <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'} icon="fa-solid fa-eye"></FontAwesomeIcon>
            </Link>

            {row.estado == 'PENDIENTE' && <Button variant={'primary'} type="button" onClick={()=>this.marcarCompletada(row)}>Completar</Button>}
          </div>
        ),
      },
    ];

    const options = {
      search: true,
      sorting: true,
      fontSize: 6,
      filtering: false,
      selection: false,
      pageSize: this.state.nuevo.limit,
      pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
      exportAllData: true,
      overflowX: "auto",
      tableLayout: "auto",
    };

    let inic = {
      lugar: { id: undefined },
      nombre: undefined,
      estado: { id: undefined },
    };

    return (
      <>
        <div className="dashboard">
          <NavBarLateral handleClose={this.handleClose} />
          <div className="dashboard__content">
            <Formik
              enableReinitialize={true}
              innerRef={bagRef}
              initialValues={inic}
              onSubmit={(values) => {
                this.setState(
                  {
                    values: values,
                    nuevaBusqueda: true
                  },
                  this.actualizar
                );
              }}
            >
              {({ values, setFieldValue, submitForm }) => (
                <Form>
                  <div className="dashboard__content-header">
                    <div className="dashboard__content-title">
                      <h2>Consultas</h2>
                    </div>
                  </div>

                  <div className="dashboard__content-main--tab">
                    <MiTabla
                      title=""
                      tableRef={tableRefUsers}
                      columns={header}
                      options={options}
                      style={{
                        tableLayout: "auto",
                        width: "100%",
                        maxWidth: "100%",
                        height: "auto",
                        borderRadius: "1rem",
                        border: "1px solid #d2d2d2",
                        boxShadow: 'none',
                        backgroundColor: 'inherit',
                        color: 'inherit'
                      }}
                      data={(query) => this.buscarData(query, false)}
                      localization={traerPalabrasTabla("Consultas")}
                    />
                  </div>
                </Form>
              )}
            </Formik>

            {this.state.alert}
          </div>
        </div>
      </>
    );
  }
}

function mapState(state) {
  const { filtros } = state.busqueda;
  return { filtros };
}

const actionCreators = {
};

const connectedConsultasAdminList = connect(mapState, actionCreators)(ConsultasAdminList);
export { connectedConsultasAdminList as ConsultasAdminList };
